import { render, staticRenderFns } from "./officeSupplies.vue?vue&type=template&id=7bd90a21&scoped=true"
import script from "./officeSupplies.vue?vue&type=script&lang=js"
export * from "./officeSupplies.vue?vue&type=script&lang=js"
import style0 from "./officeSupplies.vue?vue&type=style&index=0&id=7bd90a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd90a21",
  null
  
)

export default component.exports